var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 762 84.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #000001;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_6);\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_8);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_9);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_3);\n      }\n\n      .cls-10 {\n        fill: #f09b1b;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.95,0C6.24,0,0,6.26,0,13.99s6.24,13.99,13.95,13.99h83.86c7.7,0,13.95-6.26,13.95-13.99S105.51,0,97.81,0H13.95Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    "data-name": "Degradado sin nombre 3",
    x1: -112.57,
    y1: 872.24,
    x2: -111.05,
    y2: 872.24,
    gradientTransform: "translate(-8175.94 -64204.64) rotate(-180) scale(73.62 -73.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09689d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2bb2cc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.27,2.16L21.46,30.21c-6.5,4.11-8.44,12.73-4.33,19.24,4.1,6.51,12.69,8.46,19.19,4.34l68.81-28.05c6.5-4.11,8.44-12.73,4.33-19.24-2.65-4.2-7.16-6.5-11.77-6.5-2.54,0-5.11.7-7.42,2.16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    "data-name": "Degradado sin nombre 6",
    x1: -114.69,
    y1: 871.04,
    x2: -113.17,
    y2: 871.04,
    gradientTransform: "translate(-27291.33 -46460.79) rotate(156.98) scale(61.4 -61.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83bd8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5ba379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1b785b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#026850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026850"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.93,27.97c-7.71,0-13.95,6.26-13.95,13.99s6.24,13.99,13.95,13.99h68.88c7.7,0,13.95-6.26,13.95-13.99s-6.25-13.99-13.95-13.99H28.93Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    "data-name": "Degradado sin nombre 9",
    x1: -111.35,
    y1: 869.19,
    x2: -109.83,
    y2: 869.19,
    gradientTransform: "translate(-4843.3 -38373.76) rotate(-180) scale(44.2 -44.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3541d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#e35921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e6692d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e98342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#efa75f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3c274"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.27,30.13l-55.41,28.5c-6.49,4.11-8.43,12.73-4.33,19.24,4.1,6.51,12.69,8.46,19.19,4.34l55.41-28.5c6.5-4.11,8.44-12.73,4.33-19.24-2.65-4.2-7.16-6.5-11.77-6.5-2.54,0-5.11.7-7.42,2.16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8",
    "data-name": "Degradado sin nombre 8",
    x1: -115.53,
    y1: 869.9,
    x2: -114.01,
    y2: 869.9,
    gradientTransform: "translate(-26051.04 -34849.23) rotate(150.72) scale(49.69 -49.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f09b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a74f40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M136.84,52.03c-2.82-2.56-4.23-6.41-4.23-11.54v-15.62h-6.88v-12.32h6.88V4.08l14.08-1.41v9.89h9.81v12.32h-9.81v13.66c0,1.99.49,3.39,1.46,4.2.98.81,2.46,1.22,4.47,1.22,1.27,0,2.56-.08,3.88-.24v11.3c-3.01.58-5.64.86-7.91.86-5.01,0-8.92-1.28-11.74-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M170.37,53.17c-3.51-1.86-6.25-4.45-8.22-7.77-1.98-3.32-2.97-7.05-2.97-11.18s.99-7.93,2.97-11.22c1.98-3.3,4.71-5.87,8.19-7.73,3.48-1.86,7.43-2.79,11.86-2.79s8.38.93,11.86,2.79c3.48,1.86,6.21,4.43,8.19,7.73,1.98,3.3,2.97,7.04,2.97,11.22s-.99,7.86-2.97,11.18c-1.98,3.32-4.72,5.91-8.22,7.77-3.51,1.86-7.45,2.79-11.82,2.79s-8.32-.93-11.82-2.79ZM175.75,40.77c1.71,1.7,3.86,2.55,6.45,2.55s4.8-.85,6.48-2.55c1.69-1.7,2.53-3.88,2.53-6.55s-.84-4.85-2.53-6.55c-1.69-1.7-3.85-2.55-6.48-2.55s-4.73.85-6.45,2.55c-1.71,1.7-2.57,3.88-2.57,6.55s.86,4.85,2.57,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M217.7,53.01c-3.11-1.91-5.52-4.51-7.24-7.81-1.71-3.3-2.57-6.96-2.57-10.99s.88-7.85,2.65-11.14c1.77-3.3,4.2-5.87,7.32-7.73,3.11-1.86,6.64-2.79,10.6-2.79,4.16,0,7.96,1.13,11.39,3.37V.08h14v55.57h-11.78l-.55-4.4c-3.69,3.09-8.04,4.63-13.05,4.63-4.06,0-7.65-.95-10.76-2.86ZM224.31,40.77c1.71,1.7,3.91,2.55,6.6,2.55s4.81-.85,6.52-2.55c1.71-1.7,2.57-3.88,2.57-6.55s-.86-4.85-2.57-6.55c-1.71-1.7-3.89-2.55-6.52-2.55s-4.89.85-6.6,2.55c-1.71,1.7-2.57,3.88-2.57,6.55s.86,4.85,2.57,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M267.72,53.17c-3.51-1.86-6.25-4.45-8.22-7.77-1.98-3.32-2.97-7.05-2.97-11.18s.99-7.93,2.97-11.22c1.98-3.3,4.71-5.87,8.19-7.73,3.48-1.86,7.43-2.79,11.86-2.79s8.38.93,11.86,2.79c3.48,1.86,6.21,4.43,8.19,7.73,1.98,3.3,2.97,7.04,2.97,11.22s-.99,7.86-2.97,11.18c-1.98,3.32-4.72,5.91-8.22,7.77-3.51,1.86-7.45,2.79-11.82,2.79s-8.32-.93-11.82-2.79ZM273.1,40.77c1.71,1.7,3.86,2.55,6.45,2.55s4.8-.85,6.48-2.55c1.69-1.7,2.53-3.88,2.53-6.55s-.84-4.85-2.53-6.55c-1.69-1.7-3.85-2.55-6.48-2.55s-4.73.85-6.45,2.55c-1.71,1.7-2.57,3.88-2.57,6.55s.86,4.85,2.57,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.76,13.42h12.89l.47,4.63c1.42-1.73,3.23-3.06,5.42-4,2.19-.94,4.6-1.41,7.24-1.41,2.95,0,5.51.58,7.67,1.73,2.16,1.15,3.85,2.85,5.06,5.1,3.8-4.55,8.7-6.83,14.71-6.83,5.11,0,9.04,1.54,11.78,4.63,2.74,3.09,4.11,7.53,4.11,13.34v25.04h-14v-23.39c0-2.3-.55-4.08-1.66-5.34-1.11-1.26-2.66-1.88-4.67-1.88-2.27,0-4.06.65-5.38,1.96-1.32,1.31-1.98,3.06-1.98,5.26v23.39h-14v-23.39c0-2.3-.54-4.08-1.62-5.34-1.08-1.26-2.65-1.88-4.71-1.88-2.27,0-4.06.65-5.38,1.96-1.32,1.31-1.98,3.06-1.98,5.26v23.39h-14V13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.99,53.17c-3.51-1.86-6.25-4.45-8.22-7.77-1.98-3.32-2.97-7.05-2.97-11.18s.99-7.93,2.97-11.22c1.98-3.3,4.71-5.87,8.19-7.73,3.48-1.86,7.43-2.79,11.86-2.79s8.38.93,11.86,2.79c3.48,1.86,6.21,4.43,8.19,7.73,1.98,3.3,2.97,7.04,2.97,11.22s-.99,7.86-2.97,11.18c-1.98,3.32-4.72,5.91-8.22,7.77-3.51,1.86-7.45,2.79-11.82,2.79s-8.32-.93-11.82-2.79ZM405.37,40.77c1.71,1.7,3.86,2.55,6.45,2.55s4.8-.85,6.49-2.55c1.69-1.7,2.53-3.88,2.53-6.55s-.84-4.85-2.53-6.55c-1.69-1.7-3.85-2.55-6.49-2.55s-4.73.85-6.45,2.55c-1.71,1.7-2.57,3.88-2.57,6.55s.86,4.85,2.57,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.63,52.03c-2.82-2.56-4.23-6.41-4.23-11.54v-15.62h-6.88v-12.32h6.88V4.08l14.08-1.41v9.89h9.81v12.32h-9.81v13.66c0,1.99.49,3.39,1.46,4.2.97.81,2.46,1.22,4.47,1.22,1.27,0,2.56-.08,3.87-.24v11.3c-3.01.58-5.64.86-7.91.86-5.01,0-8.92-1.28-11.74-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.16,53.17c-3.51-1.86-6.25-4.45-8.22-7.77-1.98-3.32-2.97-7.05-2.97-11.18s.99-7.93,2.97-11.22,4.71-5.87,8.19-7.73c3.48-1.86,7.43-2.79,11.86-2.79s8.38.93,11.86,2.79c3.48,1.86,6.21,4.43,8.19,7.73,1.98,3.3,2.97,7.04,2.97,11.22s-.99,7.86-2.97,11.18c-1.98,3.32-4.72,5.91-8.22,7.77-3.51,1.86-7.45,2.79-11.82,2.79s-8.32-.93-11.82-2.79ZM487.54,40.77c1.71,1.7,3.86,2.55,6.45,2.55s4.8-.85,6.49-2.55c1.69-1.7,2.53-3.88,2.53-6.55s-.84-4.85-2.53-6.55c-1.69-1.7-3.85-2.55-6.49-2.55s-4.73.85-6.45,2.55c-1.71,1.7-2.57,3.88-2.57,6.55s.86,4.85,2.57,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519.74,13.1h12.81l.47,4.24c1.27-1.57,2.85-2.77,4.74-3.61,1.9-.84,3.98-1.26,6.25-1.26,1.42,0,3.03.21,4.82.63v12.79c-1.79-.37-3.51-.55-5.14-.55-3.22,0-5.68.84-7.39,2.51-1.71,1.68-2.57,4.13-2.57,7.38v20.41h-14V13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M551.48.08h14v17.34c1.53-1.57,3.33-2.76,5.42-3.57,2.08-.81,4.34-1.22,6.76-1.22,5.27,0,9.24,1.6,11.9,4.79,2.66,3.19,3.99,7.59,3.99,13.18v25.04h-14.08v-23.47c0-2.3-.55-4.07-1.66-5.3-1.11-1.23-2.69-1.84-4.75-1.84-2.32,0-4.16.65-5.54,1.96-1.37,1.31-2.06,3.11-2.06,5.42v23.23h-14V.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M607.43,53.17c-3.51-1.86-6.25-4.45-8.22-7.77-1.98-3.32-2.97-7.05-2.97-11.18s.99-7.93,2.97-11.22c1.98-3.3,4.71-5.87,8.19-7.73,3.48-1.86,7.43-2.79,11.86-2.79s8.38.93,11.86,2.79c3.48,1.86,6.21,4.43,8.19,7.73,1.98,3.3,2.97,7.04,2.97,11.22s-.99,7.86-2.97,11.18c-1.98,3.32-4.72,5.91-8.22,7.77-3.51,1.86-7.45,2.79-11.82,2.79s-8.32-.93-11.82-2.79ZM612.81,40.77c1.71,1.7,3.86,2.55,6.45,2.55s4.8-.85,6.49-2.55c1.69-1.7,2.53-3.88,2.53-6.55s-.84-4.85-2.53-6.55c-1.69-1.7-3.85-2.55-6.49-2.55s-4.73.85-6.45,2.55c-1.71,1.7-2.57,3.88-2.57,6.55s.86,4.85,2.57,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M644.95,13.42h12.89l.48,4.63c1.42-1.73,3.23-3.06,5.42-4,2.19-.94,4.6-1.41,7.24-1.41,2.95,0,5.51.58,7.67,1.73,2.16,1.15,3.85,2.85,5.06,5.1,3.8-4.55,8.7-6.83,14.71-6.83,5.11,0,9.04,1.54,11.78,4.63,2.74,3.09,4.11,7.53,4.11,13.34v25.04h-14v-23.39c0-2.3-.55-4.08-1.66-5.34-1.11-1.26-2.66-1.88-4.67-1.88-2.27,0-4.06.65-5.38,1.96-1.32,1.31-1.98,3.06-1.98,5.26v23.39h-14v-23.39c0-2.3-.54-4.08-1.62-5.34-1.08-1.26-2.65-1.88-4.71-1.88-2.27,0-4.06.65-5.38,1.96-1.32,1.31-1.98,3.06-1.98,5.26v23.39h-14V13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M727.99,53.17c-3.43-1.86-6.12-4.45-8.07-7.77-1.95-3.32-2.93-7.05-2.93-11.18s.96-7.93,2.89-11.22c1.92-3.3,4.6-5.87,8.03-7.73,3.43-1.86,7.3-2.79,11.63-2.79s8.2.92,11.62,2.75c3.43,1.83,6.09,4.38,7.99,7.65,1.9,3.27,2.85,6.95,2.85,11.03,0,1.2-.13,2.64-.4,4.32h-30.76c.58,1.94,1.62,3.41,3.12,4.43,1.5,1.02,3.39,1.53,5.65,1.53,1.37,0,2.65-.22,3.84-.67,1.19-.44,2.17-1.03,2.97-1.77h14.39c-1.48,4.39-4.13,7.86-7.95,10.4-3.82,2.54-8.26,3.81-13.33,3.81-4.27,0-8.12-.93-11.55-2.79ZM748.56,30.21c-.58-1.88-1.63-3.36-3.16-4.43-1.53-1.07-3.43-1.61-5.69-1.61s-4.09.52-5.62,1.57c-1.53,1.05-2.61,2.54-3.24,4.47h17.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    y: 0,
    width: 111.76,
    height: 27.97
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "134.35 49.05 28.4 94.18 -7.76 8.85 98.19 -36.28 134.35 49.05"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 14.98,
    y: 27.97,
    width: 96.78,
    height: 27.97
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "138.39 72.36 47.27 123.6 1.59 41.93 92.71 -9.3 138.39 72.36"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.c187260c874b455616130da037593c0a.svg";
export { ForwardRef as ReactComponent };